import { makeStyles } from "@material-ui/core/styles";
import carecentreTokens from "../../design-system/carecentre/tokens";

const { color, font, space, type } = carecentreTokens;

export const useStyles = makeStyles(() => ({
  catalogModalBody: {
    maxHeight: "calc(100vh - 220px)",
    overflow: "auto",
  },
  catalogFooter: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    "@media (max-width: 620px)": {
      alignItems: "stretch",
      flexDirection: "column",
    },
  },
  catalogFooterLabel: {
    display: "block",
    color: color.textMuted,
    fontSize: 11,
  },
  catalogFooterPrice: {
    display: "block",
    color: color.textInk,
    fontSize: 19,
    lineHeight: "24px",
  },
  catalogFooterActions: {
    display: "flex",
    gap: 8,
    justifyContent: "flex-end",
  },
  demoModalBody: {
    paddingTop: space[2],
  },
  catalogStatus: {
    margin: 0,
    ...type.bodySmall,
    color: color.textMuted,
  },
  catalog: {
    display: "flex",
    flexDirection: "column",
    gap: 22,
  },
  planGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 12,
    alignItems: "start",
    "@media (max-width: 620px)": {
      gridTemplateColumns: "1fr",
    },
  },
  planCard: {
    display: "flex",
    flexDirection: "column",
    background: color.bgCard,
    border: `1px solid ${color.line}`,
    borderRadius: 16,
    padding: 16,
    textAlign: "left",
    color: color.textInk,
    minWidth: 0,
    minHeight: 0,
  },
  planCardFeatured: {
    background: "linear-gradient(180deg, #efffff 0%, #f7fdff 100%)",
    border: `1.5px solid ${color.primary}`,
    boxShadow: `0 10px 28px rgba(7, 101, 255, 0.12), 0 0 0 4px ${color.primaryFaint}`,
  },
  planCardLive: {
    borderColor: color.primary,
    boxShadow: `0 0 0 3px ${color.primaryFaint}`,
  },
  planCardIncluded: {
    opacity: 0.72,
  },
  planCardHighlight: {
    borderColor: color.primary,
    boxShadow: `0 0 0 3px ${color.primaryFaint}`,
  },
  planCardDisabled: {
    opacity: 0.55,
  },
  badge: {
    display: "table",
    margin: "0 0 10px auto",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: "0.06em",
    padding: "3px 8px",
    borderRadius: 999,
    lineHeight: "14px",
    textTransform: "uppercase",
  },
  badgeTrial: {
    background: color.primarySoft,
    color: color.primaryDeep,
  },
  badgeLive: {
    background: color.successSoft,
    color: color.success,
  },
  badgeBundle: {
    background: color.bgBone,
    color: color.textMuted,
  },
  badgeFeatured: {
    background: "#C5EDE6",
    color: "#0F766E",
  },
  badgeMatch: {
    background: color.primarySoft,
    color: color.primaryDeep,
  },
  badgeWarn: {
    background: color.warningSoft,
    color: color.warning,
  },
  planLiveMeta: {
    margin: "4px 0 0",
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: 500,
    color: color.textMuted,
  },
  planCancel: {
    color: `${color.textMuted} !important`,
    "&:hover": {
      color: `${color.danger} !important`,
      background: "transparent !important",
    },
  },
  planName: {
    fontSize: 16,
    fontWeight: 700,
    color: color.textInk,
    letterSpacing: "-0.02em",
    lineHeight: "20px",
  },
  planDesc: {
    color: color.textMuted,
    fontSize: 12,
    margin: "8px 0 0",
    lineHeight: "18px",
  },
  planHtml: {
    color: color.textBody,
    fontSize: 12,
    margin: "8px 0 0",
    lineHeight: "17px",
    "& p": {
      margin: "0 0 8px",
    },
    "& p:last-child": {
      marginBottom: 0,
    },
    "& strong, & b": {
      fontWeight: 700,
      color: color.textInk,
    },
    "& ul, & ol": {
      margin: "0 0 8px",
      padding: "0 0 0 16px",
    },
    "& ul:last-child, & ol:last-child": {
      marginBottom: 0,
    },
    "& li": {
      margin: "0 0 4px",
      padding: 0,
    },
    "& li:last-child": {
      marginBottom: 0,
    },
    "& a": {
      color: color.primary,
    },
    "& img": {
      maxWidth: "100%",
      height: "auto",
    },
  },
  planPreview: {
    margin: "8px 0 0",
    maxHeight: 108,
    overflow: "hidden",
    color: color.textBody,
    fontSize: 12,
    lineHeight: "18px",
    "& > *": {
      margin: "0 !important",
    },
    "& p": {
      margin: "0 0 4px !important",
    },
    "& p:last-child": {
      marginBottom: 0,
    },
    "& ul, & ol": {
      margin: "0 !important",
      padding: "0 0 0 16px !important",
    },
    "& li": {
      margin: "0 !important",
      padding: "0 0 2px !important",
      lineHeight: "18px",
    },
    "& strong, & b": {
      fontWeight: 700,
      color: color.textInk,
    },
  },
  price: {
    fontSize: 26,
    fontWeight: 700,
    letterSpacing: "-0.03em",
    lineHeight: "32px",
    color: color.textInk,
    marginTop: 6,
    fontVariantNumeric: "tabular-nums",
  },
  priceSmall: {
    fontSize: 11,
    fontWeight: 500,
    color: color.textMuted,
  },
  featureList: {
    listStyle: "none",
    margin: "8px 0 0",
    padding: 0,
    "& li": {
      fontSize: 12,
      color: color.textBody,
      padding: "2px 0 2px 12px",
      position: "relative",
      lineHeight: "16px",
      "&:before": {
        content: '""',
        width: 5,
        height: 5,
        borderRadius: 99,
        background: color.primary,
        position: "absolute",
        left: 0,
        top: 6,
      },
    },
  },
  viewMore: {
    alignSelf: "flex-start",
    margin: "8px 0 0",
    padding: 0,
    border: 0,
    background: "none",
    color: color.primary,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "-0.01em",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
    "&:focus-visible": {
      outline: `2px solid ${color.primary}`,
      outlineOffset: 2,
      borderRadius: 4,
    },
  },
  blockedReason: {
    margin: "8px 0 0",
    color: color.textMuted,
    fontSize: 11,
    lineHeight: "16px",
  },
  cardFooter: {
    paddingTop: 12,
  },
  cardActions: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "stretch",
    gap: 8,
  },
  fullBtn: {
    flex: "1 1 0",
    minWidth: 0,
    width: "auto !important",
  },
  standaloneSection: {
    marginTop: 28,
    paddingTop: 22,
    borderTop: `1px solid ${color.lineSoft}`,
  },
  standaloneLabel: {
    margin: "0 0 16px",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: color.textMuted,
  },
  addonGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 14,
    "@media (max-width: 900px)": {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    "@media (max-width: 520px)": {
      gridTemplateColumns: "1fr",
    },
  },
  addonCard: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    padding: "16px 16px 14px",
    borderRadius: 16,
    border: `1px solid ${color.line}`,
    background: color.bgCard,
    boxShadow:
      "0 1px 3px rgba(21, 25, 31, 0.04), 0 4px 12px rgba(21, 25, 31, 0.02)",
    transition:
      "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
    "&:hover": {
      transform: "translateY(-2px)",
      borderColor: "rgba(7, 101, 255, 0.35)",
      boxShadow:
        "0 8px 24px -4px rgba(7, 101, 255, 0.12), 0 2px 6px rgba(21, 25, 31, 0.04)",
      "& $addonIconBox": {
        transform: "scale(1.08)",
        background: color.primary,
        color: "#FFFFFF",
      },
    },
  },
  addonCardLive: {
    background: "linear-gradient(180deg, #FFFFFF 0%, #F5FAF7 100%)",
    borderColor: "rgba(34, 197, 94, 0.35)",
  },
  addonCardHighlight: {
    borderColor: color.primary,
    boxShadow: `0 0 0 2px ${color.primarySoft}`,
  },
  addonHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    marginBottom: 12,
  },
  addonIconBox: {
    width: 36,
    height: 36,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: color.primarySoft,
    color: color.primaryDeep,
    flexShrink: 0,
    transition: "all 180ms ease",
    "& svg": {
      width: 18,
      height: 18,
    },
  },
  addonBody: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  addonName: {
    margin: 0,
    fontFamily: font.display,
    fontSize: 15.5,
    lineHeight: "20px",
    fontWeight: 700,
    letterSpacing: "-0.015em",
    color: color.textInk,
  },
  addonPrice: {
    margin: "6px 0 6px",
    fontSize: 20,
    lineHeight: "24px",
    fontWeight: 800,
    letterSpacing: "-0.02em",
    color: color.textInk,
    fontVariantNumeric: "tabular-nums",
    display: "flex",
    alignItems: "baseline",
    gap: 4,
    "& small": {
      fontSize: 11.5,
      fontWeight: 500,
      color: color.textMuted,
      letterSpacing: "normal",
    },
  },
  addonDesc: {
    margin: 0,
    fontSize: 12,
    lineHeight: "17px",
    color: color.textBody,
  },
  addonBadge: {
    margin: 0,
    flexShrink: 0,
  },
  addonFooter: {
    marginTop: 14,
    paddingTop: 12,
    borderTop: `1px solid ${color.lineSoft}`,
    display: "flex",
    alignItems: "center",
  },
  addonBuy: {
    width: "100% !important",
    minHeight: "32px !important",
    fontSize: "12px !important",
    fontWeight: "600 !important",
    borderRadius: "8px !important",
  },
  addonActiveStatus: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    width: "100%",
    fontSize: 12,
    fontWeight: 600,
    color: color.success,
    padding: "4px 0",
  },
  addonUnavailable: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: color.textQuiet,
    textAlign: "center",
    width: "100%",
  },
}));
